import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from 'src/app/api/core/auth/auth.service';
import { BaseWalkthroughStepComponent } from '../base-walkthrough-step/base-walkthrough-step.component';

@Component({
  selector: 'hub-main-walkthrough-intro',
  templateUrl: './main-walkthrough-intro.component.html',
  styleUrls: ['./main-walkthrough-intro.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainWalkthroughIntroComponent extends BaseWalkthroughStepComponent {
  constructor(public el: ElementRef, public auth: AuthService) {
    super(el);
  }

  ngOnDestroy() {
    console.log('MAIN INTRO DESTROYED');
  }
}
